import type { IconProps } from '../types/IconProps.ts';
export const CircleChevronUp: IconProps = {
    name: 'CircleChevronUp',
    children: [
        `<path d="m8 14 3.65-3.65c.2-.2.5-.2.7 0L16 14" />`,
        `<path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20" />`,
    ]
};